import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What counts toward the AI quota?",
    a: "Two operation types: drafts and summaries. A draft is when AntAtlas writes a proposed Confluence update for a stale page — counted once per proposal. A summary is a per-page change explanation generated whenever code changes affect a documented page. Match signals (the LLM-assisted doc-to-code matching) don't count — they're included on all paid tiers without metering. Team includes 100 drafts and 500 summaries per month; Business includes 400 drafts and 2,000 summaries.",
  },
  {
    q: "What happens if I exceed the quota?",
    a: "Overage is metered transparently at $0.50/draft and $0.05/summary for Team; $0.40/draft and $0.04/summary for Business. We auto-cap overage at 2× your subscription unless you explicitly opt in — so a $390/mo Team account will never see a $5,000 invoice. You get email alerts at 50%, 80%, and 100% of quota before any overage starts.",
  },
  {
    q: "Can I cancel mid-month?",
    a: "Team is monthly billing with 30-day cancel — cancel any time, pay through the end of the current period, no questions. Business is quarterly or annual — annual gets 15% off. Enterprise is annual minimum. We never auto-renew enterprise contracts; you'll always confirm intent before the next term.",
  },
  {
    q: "Do you offer YC or accelerator discounts?",
    a: "Yes. YC alumni get 50% off the Team tier for the first 12 months — that's $195/mo. Send proof of active or alumni status when you apply for the pilot. We extend the same discount to a few other accelerators (TinySeed, On Deck, Antler) on request. It applies to Team only, not Business or Enterprise.",
  },
  {
    q: "What's BYOK and how does it work?",
    a: "BYOK (Bring Your Own Key) is an Enterprise option at $2,900/mo flat. You provide your own Anthropic API key; AntAtlas never sees your tokens. We bill you a flat subscription for the platform, and you pay Anthropic directly for AI usage on your own contract. This gives compliance teams comfort that no cross-tenant token leakage is possible, and removes margin risk for power users who would otherwise burn through quota.",
  },
  {
    q: "Do you support EU customers?",
    a: "Yes. We collect and remit VAT via Stripe Tax (One Stop Shop registration), so EU customers get proper VAT-inclusive invoices. We're a US-incorporated entity by Phase 3 of our rollout — until then EU customers are billed by the Portuguese sole proprietorship of the founder. GDPR-compliant DPA available on request. EU data residency is on the Enterprise roadmap, not standard.",
  },
  {
    q: "What's the refund policy?",
    a: "We don't lock you in. If AntAtlas isn't surfacing useful stale docs in your first 30 days on a paid plan, email us and we'll refund that month — no questions asked. We'd rather refund a single month than have a customer who isn't getting value churn quietly. After 30 days, cancellation is the path (Team monthly cancel, Business quarterly).",
  },
  {
    q: "How do you handle our Confluence and GitHub data?",
    a: "Read-only by default. Our GitHub App takes read scopes for code and PRs; Confluence OAuth starts with read-only scopes and only requests write when you turn on approval-gated proposals. We don't retain source files at rest beyond what's needed for the doc-code graph and match evidence (typically a few KB per page). Every match decision is in an audit log linked to the actor. See our Privacy and Security pages for the long form.",
  },
];

const PricingFAQ = () => (
  <section className="section-padding bg-surface-subtle" id="pricing-faq">
    <div className="container-narrow">
      <div className="text-center mb-12">
        <p className="text-xs font-medium uppercase tracking-widest text-accent mb-3">
          Pricing FAQ
        </p>
        <h2 className="heading-lg mb-4">Questions buyers ask before they pay.</h2>
      </div>

      <Accordion type="single" collapsible className="w-full">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`pricing-faq-${i}`}>
            <AccordionTrigger className="text-left text-base font-semibold">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default PricingFAQ;
